module Elma.ViewModels { 
    export class ProductListViewModel extends Tapas.ViewModels.ProductListViewModel {
        public mvm: Elma.ViewModels.MasterViewModel = Ftw.Base.Config.MasterViewModel as Elma.ViewModels.MasterViewModel;
        public productArray = ko.observableArray();
        public compareCount = ko.observable(0);
        public showMaxCountError = ko.observable(false);
        constructor() {
            super();
            this.mvm.listMode.subscribe((newValue) => {
                this.mode(newValue);
            });

            this.mvm.compareProductsArray.subscribe((newValue) => {
                this.productArray(newValue); // update values
                this.compareCount(this.productArray().length); // update count

                if (this.compareCount() > 3) {
                    this.showMaxCountError(true);
                    this.mvm.compareProductsArray.pop(); // delete last element
                }

            });
        }

        public removeMaxCountError = () => {
            this.showMaxCountError(false);
        }

        public toggleView = () => {
            switch (this.mvm.listMode() as any) {
                case "list":
                    this.mvm.listMode(Mode.Grid);
                    break;

                case "grid":
                    this.mvm.listMode(Mode.List);
                    break;
            }
        }   
    }
}